export default __webpack_public_path__ + "static/media/Hemkunskap9.2e8b58c9.jpeg";